<h1 mat-dialog-title>{{ 'aumico_admin_change_fcpstate_select_fcp_status' | i18next }}</h1>
<div mat-dialog-content>
    <mat-form-field appearance="fill">
        <mat-label>{{ 'aumico_admin_change_fcp_statefcp_status' | i18next }}</mat-label>
        <mat-select [(value)]="data.fcpStatus">
            <mat-option *ngFor="let status of statuses" [value]="status" [disabled]="data.fcpStatus === status">{{
                status
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{ 'aumico_admin_change_fcpstate_cancel' | i18next }}</button>
    <button mat-button (click)="save()">{{ 'aumico_admin_change_fcpstate_confirm' | i18next }}</button>
</div>
